<div class="row" [formGroup]="attributeValuesForm">
  <ng-container formArrayName="attributes">
    @for (attribute of attributesArray.controls; track attribute; let i = $index) {
      <ng-container [formGroupName]="i">

        <!-- Fixed values: dropdown -->
        @if (isFixedValuesAttribute(attribute)) {
          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <label class="block text-sm" [for]="fieldIdPrefix + '-' + definitions[i].id">
              {{ getAttributeLabel(definitions[i]) }}
            </label>

            <app-custom-dropdown
              [attr.data-testid]="fieldIdPrefix + '-' + definitions[i].id"
              [placeholder]="('ATTRIBUTE_VALUES_FORM.SELECT' | translate) + ' ' + getAttributeLabel(definitions[i]).toLowerCase()"
              optionLabel="text"
              optionValue="id"
              [isMultiselect]="allowsMultipleValues(attribute)"
              [showSelectionChips]="true"
              [showClear]="true"
              [showSearchbox]="true"
              [searchMode]="'local'"
              [pageSize]="10"
              [options]="getDropdownOptions(definitions[i])"
              formControlName="value">
            </app-custom-dropdown>
          </div>
        }

        <!-- Text, integer or decimal: single value -->
        @if (!isFixedValuesAttribute(attribute) && !allowsMultipleValues(attribute)) {
          <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <label class="block text-sm" [for]="fieldIdPrefix + '-single-' + definitions[i].id">
              {{ getAttributeLabel(definitions[i]) }}
            </label>

            @if (isTextAttribute(attribute)) {
              <input [id]="fieldIdPrefix + '-single-' + definitions[i].id" type="text" formControlName="value" autocomplete="off">
            } @else {
              <input [id]="fieldIdPrefix + '-single-' + definitions[i].id" type="number"
              [step]="isIntegerAttribute(attribute) ? '1' : '0.01'" formControlName="value" autocomplete="off">
            }

            @if (attribute.get('value')?.touched && attribute.get('value')?.hasError('pattern')) {
              <small class="p-error">{{ 'FORMS.INVALID_FORMAT' | translate }}</small>
            }
          </div>
        }

        <!-- Text, integer or decimal: multiple values -->
        @if (!isFixedValuesAttribute(attribute) && allowsMultipleValues(attribute)) {
          <ng-container formArrayName="values">
            @for (valueControl of getMultipleValuesArray(i).controls; track valueControl; let j = $index) {
            <div class="field-wr btn-field flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <label class="block text-sm mb-2" [for]="fieldIdPrefix + '-' + definitions[i].id + '-' + j">
                {{ getAttributeLabel(definitions[i]) }} #{{ j + 1 }}
              </label>

              <div class="attribute-value-field">
                <div class="attribute-value-control">
                  @if (isTextAttribute(attribute)) {
                    <input [id]="fieldIdPrefix + '-' + definitions[i].id + '-' + j" type="text" [formControlName]="j" autocomplete="off">
                  } @else {
                    <input [id]="fieldIdPrefix + '-' + definitions[i].id + '-' + j" type="number" [step]="isIntegerAttribute(attribute) ? '1' : '0.01'" [formControlName]="j" autocomplete="off">
                  }

                  @if (getMultipleValuesArray(i).length > 1) {
                    <button type="button" data-testid="remove-attribute-value-btn" class="btn primary-btn remove-btn" pTooltip="{{ 'ATTRIBUTE_VALUES_FORM.BTN_REMOVE_VALUE' | translate }}" tooltipPosition="top" (click)="removeMultipleValue(i, j)">
                      <span class="hide">{{ 'ATTRIBUTE_VALUES_FORM.BTN_REMOVE_VALUE' | translate }}</span>
                    </button>
                  }

                  @if (j === getMultipleValuesArray(i).length - 1 && getMultipleValuesArray(i).length < maxMultipleValues ) {
                    <button type="button" data-testid="add-attribute-value-btn" class="btn primary-btn add-btn" pTooltip="{{ 'ATTRIBUTE_VALUES_FORM.BTN_ADD_VALUE' | translate }}" tooltipPosition="top" (click)="addMultipleValue(i)">
                      <span class="hide">{{ 'ATTRIBUTE_VALUES_FORM.BTN_ADD_VALUE' | translate }}</span>
                    </button>
                    }
                </div>

                @if (valueControl.touched && valueControl.hasError('pattern')) {
                  <small class="p-error">{{ 'FORMS.INVALID_FORMAT' | translate }}</small>
                }
              </div>
            </div>
            }
          </ng-container>
        }

      </ng-container>
    }
  </ng-container>
</div>
